export default __webpack_public_path__ + "static/media/roadmap-mobile-2.79138b33.png";